import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
 import HomeView from '../views/HomeView.vue'
 
const routes: Array<RouteRecordRaw> = [
   {
    path: '/',
    name: 'home',
    component: HomeView,
      meta: { requiresAuth: true }  // 商品列表不需要登录
  },
  ,  {
    path: '/Products/ProductsCategory/',
    name: 'ProductsCategory',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Products/ProductsCategory.vue')
  },  {
    path: '/Products/Cart/',
    name: 'Cart',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Products/Cart.vue')
  }, {
    path: '/Products/ProductsDetails/',
    name: 'ProductsDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Products/ProductsDetails.vue')
  },
  {
    path: '/',
    name: 'shopList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/ShopView.vue')
  },
  {
    path: '/Login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
  } ,{
    path: '/shop/shoplist/:page',
    name: 'shopList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/ShopView.vue')
  },  {
    path: '/shop/ShopCreate/:id',
    name: 'ShopCreate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/ShopCreateView.vue')
  },  {
    path: '/shop/ShopDetails/',
    name: 'ShopDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/ShopDetailsView.vue')
  },  {
    path: '/shop/ShopbusinesshoursSetting/',
    name: 'ShopbusinesshoursSetting',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/ShopbusinesshoursSetting.vue')
  }
  ,  {
    path: '/Alipay/AlipaySuccess/',
    name: 'AlipaySuccess',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Alipay/AlipaySuccess.vue')
  }
 ,{
    path: '/Orders/OrderList',
    name: 'OrderList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Orders/OrderList.vue')
  },{
    path: '/Orders/OrderDetails',
    name: 'OrderDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Orders/OrderDetails.vue')
  }
,{
    path: '/Shop/Classificationsettings/',
    name: 'Classificationsettings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Shop/Classificationsettings.vue')
  }
,{
    path: '/Users/PersonalCenter/',
    name: 'PersonalCenterView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Users/PersonalCenterView.vue')
  }
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
 let _currentFullPath = '/'
  let _currentFullPaths= '/'

router.afterEach((to:any, from:any) => {
  _currentFullPath = from.fullPath
})
router.afterEach((to:any, from:any) => {
  _currentFullPaths = to.fullPath
})


// 获取最新路由路径
export function getCurrentFullPath() {
  return _currentFullPath
}
export function getNewCurrentFullPath() {
  return _currentFullPath
}
export default router
